import { Outlet } from "react-router";

export default function AuthLayout() {
	return (
		<div className="min-h-screen bg-background relative">
			{/* Gradient mesh background */}
			<div className="gradient-mesh">
				<div className="gradient-mesh-blob-3" />
			</div>

			{/* Mobile: top-aligned with a fixed offset — vertical centering
			    wastes space above and fights the on-screen keyboard.
			    Desktop: centered split-card as before. */}
			<div className="relative z-10 min-h-screen flex items-start lg:items-center justify-center px-4 pt-8 pb-8 lg:py-8">
				<Outlet />
			</div>
		</div>
	);
}
